import React from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import JobHistoryTimelineItem from "./JobHistoryTimelineItem";
import JobHistoryTimelineItemLoading from "./JobHistoryTimelineItemLoading";
import Loading from "customHooks/useCompleoForm/helpers/Loading";

const useStyles = makeStyles((theme: Theme) => createStyles({}));

const JobHistoryRow = (props: any) => {
    const classes = useStyles();
    const { data, index, style } = props;
    const { historyData, tLocal } = data;
    const historyItem = historyData[index];

    if (historyItem !== undefined) {
        return (
            <div style={style}>
                <JobHistoryTimelineItem
                    historyItem={historyItem}
                    tLocal={tLocal}
                />
            </div>
        );
    }
    return (
        <div style={style}>
            <JobHistoryTimelineItemLoading
                historyItem={historyItem}
                tLocal={tLocal}
            />
        </div>
    );
};

export default JobHistoryRow;
